import { erpAxios } from '..';

const getUserApplications = async (id) => {
  const { data } = await erpAxios(`/loanApplication/getUserApplications/${id}`);
  return data;
};

export default getUserApplications;